export default {
  "b2b.page-title.prehled": "Přehled",
  "b2b.page-title.provozni-informace": "Provozní informace",
  "b2b.page-title.provozni-informace.nova": "Nová provozní informace",
  "b2b.page-title.provozni-informace.editace": "Editace provozní informace",
  "b2b.page-title.provozni-informace.detail": "Detail provozní informace",
  "b2b.page-title.rezervace": "Rezervace",
  "b2b.page-title.rezervace.historie": "Historie žádostí",
  "b2b.page-title.rezervace.odbaveni": "Odbavení žádostí",
  "b2b.page-title.rezervace.vytvoreni": "Nová rezervace",
  "b2b.page-title.rezervace.casovy-plan": "Časový plán",
  "b2b.page-title.administrace": "Administrace",
  "b2b.page-title.administrace.smlouva": "Smlouva",
  "b2b.page-title.administrace.projekt": "Projekt",
  "b2b.page-title.administrace.zakaznici": "Zákazníci",
  "b2b.page-title.administrace.zdroje": "Zdroje"
};
